
<template>
    <div class= "col-md-12 ml-sm-0 col-lg-12 pt-0 px-0 pl-0">
        <div class="row mx-0">
            <div class ="col-md-3 ml-sm-0 col-lg-3 pt-1 px-1 pl-5">
            </div>
            <div class ="col-md-6 ml-sm-0 col-lg-6 pt-1 px-1 pl-5">
                   
                <div  v-for="(Country, index) in Countries" :key="index">
                    <div class="row mx-0">
                        <div class ="col-md-3 ml-sm-0 col-lg-3 pt-1 px-1 pl-5">
                            <input type="text" :id ='Country' class="form-control  pl-5" v-model='Countries[index]'/>
                        </div>
                        <div class ="col-md-6 ml-sm-0 col-lg-6 pt-1 px-1 pl-5">
                            <input type="number" :id ='Country' class="form-control  pl-5" v-model='Coefficient[index]'/>
                        </div>
                        <div class ="col-md-3 ml-sm-0 col-lg-3 pt-1 px-1 pl-5">
                            <button type="button" class="buttonOriginal" aria-label="Left Align" v-on:click="del(index)" :title="trans.get('common.delete')">
                                <span class="glyphicon glyphicon-trash" aria-hidden="true"></span>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="row mx-0">
                    <div class ="col-md-3 ml-sm-0 col-lg-3 pt-1 px-1 pl-5">
                        
                    </div>
                    <div class ="col-md-6 ml-sm-0 col-lg-6 pt-1 px-1 pl-5">
                           
                    </div>
                    <div class ="col-md-3 ml-sm-0 col-lg-3 pt-1 px-1 pl-5">
                        <button type="button" class="buttonOriginal" aria-label="Left Align" v-on:click="add()" :title="trans.get('common.add')">
                            <span class="glyphicon glyphicon-plus" aria-hidden="true"></span>
                        </button>
                    </div>
                    
                </div>
            </div>
            <div class ="col-md-3 ml-sm-0 col-lg-3 pt-1 px-1 pl-5">
            </div>
        </div>
        <div class="row mx-0">
            <div class="col-md-6 ml-sm-0 col-lg-6 pt-1 px-1 pl-5">
            </div>
            <div>
                <input name="coeff" type="hidden" id="coeff" style="visibility:hidden" >
                <button type="button" class="buttonOriginal" aria-label="Left Align" v-on:click='save()' :title="trans.get('common.save')">
                    <span class="glyphicon glyphicon-floppy-save" aria-hidden="true"></span>
                </button>
                &nbsp;
                <a class="buttonOriginal" :title="trans.get('common.restore_init')" :href='pathRestore'><span  class="glyphicon glyphicon-repeat" ></span></a>
            </div>
        </div>

    </div>
</template>

<script >
    export default {
        props : ['coeff', 'pathRestore'],     
        
        data : function(){
            return {
                Countries :[],
                Coefficient:[],
                CoeffCountry : {},
                Opex:[],
                Implement:0,

            };
        },
        mounted: function(){
            var data = JSON.parse(this.coeff);
            this.Countries = Object.keys(data);
            this.Coefficient = Object.values(data);
            this.CoeffCountry = data;
        },
        methods :{
        
            del(index){
                this.Countries.splice(index,1);
                this.Coefficient.splice(index,1);
            },
            add(){
                this.Countries.push("Pays");
                this.Coefficient.push(0);
            },
            save(){
                var data = {};

                for( let i=0; i< this.Countries.length; i++){
                    var x = this.Countries[i];
                    var y = this.Coefficient[i];
                    var temp = {};
                    temp[x] = y;
                    Object.assign(data, temp);
                }
                
                document.getElementById('coeff').value = JSON.stringify(data);
                document.getElementById("formPost").submit();
            },
        }

    }

</script>
